///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

function ProgressBar({ currentStep }) {
  return (
    <div>
      <ul id="progressbar" className="progressbar">
        <li
          data-testid="bid-information"
          className={`${currentStep === 1 ? "current" : ""} ${
            currentStep > 1 ? "active" : ""
          }`}
        >
          <span
            className={`weight--semibold ${
              currentStep !== 1 ? "text-light-grey" : ""
            }`}
          >
            {messages.bidInformation.defaultMessage}
          </span>
        </li>
        <li
          data-testid="mode-information"
          className={`${currentStep === 2 ? "current" : ""} ${
            currentStep > 2 ? "active" : ""
          }`}
        >
          <span
            className={`weight--semibold ${
              currentStep !== 2 ? "text-light-grey" : ""
            }`}
          >
            {messages.modeInformation.defaultMessage}
          </span>
        </li>
        <li
          data-testid="bid-strategy"
          className={`${currentStep === 3 ? "current" : ""} ${
            currentStep > 3 ? "active" : ""
          }`}
        >
          <span
            className={`weight--semibold ${
              currentStep !== 3 ? "text-light-grey" : ""
            }`}
          >
            {messages.bidStrategy.defaultMessage}
          </span>
        </li>
        <li
          data-testid="review-bid"
          className={`${currentStep === 4 ? "current" : ""}`}
        >
          <span
            className={`weight--semibold ${
              currentStep !== 4 ? "text-light-grey" : ""
            }`}
          >
            {messages.reviewAndSubmit.defaultMessage}
          </span>
        </li>
      </ul>
    </div>
  );
}

export default ProgressBar;
